import { ValidationError } from '../../models/projects/validation.models';
import { menuSectionFor } from '../nav/menu-sections';

export const sectionNotCompletedCode = 'section.not_completed';

export function isIncompleteSection(error: ValidationError): boolean {
  // Unknown sections and older API responses keep their full detailed messages.
  return error.code === sectionNotCompletedCode && !!menuSectionFor(error.pageValidationType);
}



// WEBPACK FOOTER //
// ./src/services/validation/incomplete-sections.ts